// extracted by mini-css-extract-plugin
export var container = "_kn-0";
export var dotAnimation = "_kn-2";
export var dotsLoading = "_kn-1";